import * as React from 'react';
import { useEffect,useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
// import menuicon from '../../assets/menu.svg';
import logo from "../../assets/logo-modified.svg";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import { Paper, InputBase } from '@mui/material';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export default function PersistentDrawerLeft({ selectedFile, setSelectedFile, filesList ,handleFileSelect}) {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [filteredFiles, setFilteredFiles] = useState([])
    const [searchTerm, setSearchTerm] = React.useState("");
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };

    useEffect(()=>{
        let filtered=filesList.filter(file => file.toLowerCase().includes(searchTerm));
        setFilteredFiles(filtered)
    }, [searchTerm, filesList])

    const handleFileSelection=(path,index)=>{
        handleFileSelect(path,index)
        handleDrawerClose()
    }

    return (
        <>
            <Toolbar className='toolbar'>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={[open && { display: 'none' }]}
                >
                    <MenuIcon title='menu' className='file-menu-icon' />
                    {/* <img src={menuicon} className='file-menu-icon' alt="menu icon" /> */}
                </IconButton>
            </Toolbar>
            <Drawer
                sx={{
                    flexShrink: 100,
                    '& .MuiDrawer-paper': {
                        width: 250,
                        boxSizing: 'border-box',
                    },
                }}
                className='drawer-container'
                variant="persistent"
                // variant="permanent"
                anchor="left"
                open={open}
            >
                <DrawerHeader>
                    <img
                        src={logo}
                        alt="logo"
                        width="160"
                        className="d-inline-block align-text-top menu-logo"
                    />
                    <IconButton onClick={handleDrawerClose} className='close-btn-container'>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon className='close-menu-icon' /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Paper component="form" className='search-input-container'>
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search File..."
                        inputProps={{ 'aria-label': 'search file' }}
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search" className='search-button'>
                        <SearchIcon />
                    </IconButton>
                </Paper>
                <List className='collection-files' style={{borderTop:'1px solid #dfe6e9'}}>
                    {filteredFiles.map((text,index) => {
                        const fileName=text.split('/').pop()
                        return <>
                        {fileName.includes('.pdf') && (
                            <ListItem key={text} disablePadding className={selectedFile==text ? 'selected-file file-list-element ':'file-list-element'} onClick={()=>handleFileSelection(text,index)}>
                                <Tooltip title={fileName.replace('.pdf','')} placement="top" followCursor>
                                    <ListItemButton className='file-name'>
                                        <ListItemText className='file-name-text' primary={fileName.replace('.pdf','')} />
                                    </ListItemButton>
                                </Tooltip>
                            </ListItem>
                        )}
                        </>
                    })}
                </List>
            </Drawer>
        </>
    );
}
